import { useEffect, useRef } from 'react';
import { playNotificationSound } from '../services/notificationSound';
import { useNotificationSetting } from './useNotificationSetting';

// มาหลายเคสพร้อมกันให้ติ๊งครั้งเดียว ไม่รัวเป็นปืนกล
const DEBOUNCE_MS = 3000;

/**
 * ติ๊งเมื่อ "จำนวนงานของฉัน" เพิ่มขึ้น
 *
 * ส่ง count ที่ยังไม่ผ่านช่องค้นหา/ตัวกรองเข้ามาเสมอ —
 * ถ้าส่งตัวที่กรองแล้ว พอผู้ใช้ลบข้อความในช่อง Filter ตัวเลขจะเด้งขึ้นแล้วติ๊งมั่ว
 *
 * @param {number|null|undefined} count จำนวนงานของฉันตอนนี้
 */
export const useNewWorkSound = (count) => {
  const prevCount = useRef(null);
  const lastPlayedAt = useRef(0);
  const { byType } = useNotificationSetting();
  const setting = byType('new_work');

  useEffect(() => {
    // ยังโหลดไม่เสร็จ / เพิ่งสลับบริษัท (cache ถูกล้าง) → รีเซ็ตฐานเทียบ
    // ไม่งั้นค่าของบริษัทเก่าจะถูกเอามาเทียบกับบริษัทใหม่แล้วติ๊งมั่ว
    if (count == null) {
      prevCount.current = null;
      return;
    }

    // ค่าแรกที่โหลดได้ไม่ใช่ "งานใหม่" — เป็นแค่ยอดค้างที่มีอยู่เดิม
    if (prevCount.current === null) {
      prevCount.current = count;
      return;
    }

    if (count > prevCount.current && setting?.enabled !== false) {
      const now = Date.now();
      if (now - lastPlayedAt.current >= DEBOUNCE_MS) {
        lastPlayedAt.current = now;
        playNotificationSound({
          soundUrl: setting?.soundUrl,
          volume: setting?.volume ?? 0.8,
        });
      }
    }

    prevCount.current = count;
  }, [count, setting]);
};

export default useNewWorkSound;
